
import { computed, PropType, defineComponent, provide, ref, defineEmits } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { Slide } from '@/types/slides'
import { injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'

import ThumbnailElement from './ThumbnailElement.vue'

export default defineComponent({
  name: 'thumbnail-slide',
  components: {
    ThumbnailElement,
  },
  props: {
    slide: {
      type: Object as PropType<Slide>,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    }   
  },
  emits: {
    selectIndex: null
  },
  setup(props, {emit}) {
    const { viewportRatio, slides, slideIndex } = storeToRefs(useSlidesStore())
    const slideId = ref('')
    const background = computed(() => props.slide.background)
    const { backgroundStyle } = useSlideBackgroundStyle(background)  
    const scale = computed(() => props.size / VIEWPORT_SIZE)
    provide(injectKeySlideScale, scale)

    const thumbnailClick = () => {
      

      // slideId.value = slides.value[0].id
      // slidesStore.updateSlideIndex(5)
      // console.log(slides.value, slideIndex.value, 123144)
      emit('selectIndex', slideIndex.value)
    }
    return {
      scale,
      backgroundStyle,
      VIEWPORT_SIZE,
      viewportRatio,
      thumbnailClick      
    }
  },
})
